// extracted by mini-css-extract-plugin
export var container = "aboutText-module--container--O5mL8";
export var textContainer = "aboutText-module--textContainer--6Cw8Q";
export var titleContainer = "aboutText-module--titleContainer--O04x3";